import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Badge as BaseBadge } from '../../../CommonComponents/OPL/Badge/Badge';
import { useUnreadNewsfeedCountQuery } from '../../api/useUnreadNewsfeedCountQuery';
import { isConsumerArea } from '../../../CommonSelectors/CommonAreaSelector';

export const Badge = styled(BaseBadge)(({ theme }) => ({
  position: 'absolute',
  top: `-${theme.space[8]}px`,
  right: `-${theme.space[16]}px`,
}));

export const UnreadNewsfeedCountBadge = () => {
  const isConsumer = useSelector(isConsumerArea);
  const { data, isLoading } = useUnreadNewsfeedCountQuery(isConsumer);

  if (isLoading || !data) {
    return null;
  }

  return (
    <Badge maxDigits={2} variant="notification">
      {data}
    </Badge>
  );
};
